import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { A11yModule } from '@angular/cdk/a11y';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ThemeToggleComponent } from './theme-toggle/theme-toggle.component';
import { OtpVerificationBlockComponent } from './otp-verification-block/otp-verification-block.component';
import { CustomSelectComponent } from './custom-select/custom-select.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    ThemeToggleComponent,
    OtpVerificationBlockComponent
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    ThemeToggleComponent,
    OtpVerificationBlockComponent,
    CustomSelectComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    A11yModule,
    CustomSelectComponent
  ]
})
export class SharedModule { }
